import {
  number as yupNumber,
  object as yupObject,
} from 'yup';

export const customSubmitFactory = (formik, callback) => () => {
  // We submit because formik touches all fields, validates and shows
  // errors. But the default onSubmit should be a dummy function.
  formik.handleSubmit();

  if (!formik.isValid) {
    return;
  }

  callback(formik.values);
};

export const resetField = (formik, fieldName) => {
  formik.setFieldValue(fieldName, formik.initialValues[fieldName]);
  formik.setFieldTouched(fieldName, false);
};

export const resetFieldsExcept = (formik, fieldNames) => {
  Object.keys(formik.values)
    .filter(fieldName => !fieldNames.includes(fieldName))
    .forEach(fieldName => resetField(formik, fieldName));
};

export const yupAmount = yupObject({
  net: yupNumber().typeError('Net Amount must be a number.'),
  gross: yupNumber().typeError('Gross Amount must be a number.').nullable(),
});
